import styled from "styled-components";

export const TituloContainer = styled.div`
  width: 100%;

  .titulo {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 1.5rem;
    margin-bottom: 5rem;
    width: 100%;
    padding: 0 3rem;

    .subtitulo {
      color: ${(props) => props.theme.colors.tertiary};
    }

    .barra {
      color: ${(props) => props.theme.colors.tertiary};
    }

    .laranja {
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${(props) => props.theme.colors.secondary};
    }

    .bloqueado{
      color: ${(props) => props.theme.colors.disable};
      display: flex;
      align-items: center;
      justify-content: center;
    }

    svg{
      width: 3rem;
      margin-bottom: 2px;
    }
 
  }
  @media (max-width: 400px) {
    .titulo {
      padding: 0;
      gap: 1rem !important;
    }
  }
`;
